// extracted by mini-css-extract-plugin
module.exports = {"SideBySide":"PropertiesViewer_SideBySide__2Qzwi","Divider":"PropertiesViewer_Divider__1WZUf"};